export function ucfirst(str) {
  return str[0].toUpperCase() + str.slice(1);
}

export function shortname(name) {
  if (!name) return "";
  const omitWords = ["kbo", "radiotaxi", "de", "wg"];
  const words = name
    .normalize("NFD")
    .split(/\s|_|-/)
    .filter((segment) => segment.match(/\b/))
    .filter((segment) => omitWords.indexOf(segment.toLowerCase()) < 0)
    .slice(0, 2);
  if (words.length > 1) {
    return words
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  }
  return (words[0] || name.slice(0, 2)).split("").slice(0, 2).join("").toUpperCase();
}

export function fixedWidth(text, width = 20) {
  if (width <= text.length) return text;
  return text + new Array(width - text.length).fill(" ").join("");
}

export function truncate(text, length = 300) {
  if (text?.length < length) return text || "";
  return text.substring(0, length) + "...";
}

export function nl2br(text) {
  return text.replace(/\n/g, "<br />");
}

export function cleanupNullString(text) {
  return text.toLowerCase() === "null" ? "" : text;
}
